/**
 * @desc 导出报关箱单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(cbNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/exportDeclaration/${cbNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
